const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const teamPopup = {

	$popupTrigger: $('.js-team-popup-trigger'),
	$popup: $('.js-team-popup'),
	$popupInner: $('.js-teams-popup-inner'),
	$closeIcon: $('.js-team-popup-close'),

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$popupTrigger.on('click', this.openPopup);
		this.$closeIcon.on('click', this.closePopup);
		Global.escKey(this.closePopup);
		Global.clickOutsideContainer(Global.$domBody, this.$popupInner, this.$closeIcon, this.closePopup);
	},

	openPopup: function() {
		const popupNumber = $(this).data('team');
		const popup = $(`.js-team-popup[data-team="${popupNumber}"]`);
		popup.addClass('active');
		$(document.body).addClass('overflow-active');
	},

	closePopup: function() {
		teamPopup.$popup.removeClass('active');
		$(document.body).removeClass('overflow-active');
	},

};

export default teamPopup;
